/*
 * @Author: 冯杰
 * @Date: 2021-10-12 20:33:06
 * @LastEditTime: 2021-10-13 14:45:08
 * @FileName: 消费者红包提现明细
 */
import TablePage from '@/found/components/table_page';
import Modal from '@/found/components/modal';
import request from '@/found/utils/request';

export default {
  name: 'ConsumerRedpacketWithdraw',
  extends: TablePage,
  data() {
    return {
      requestUrl: '/cps/v1/cashRecord/cashRecordReport/findConsumerByConditions',
      requestType: 'GET',
    };
  },
  components: {
    Modal,
  },
  methods: {},
  created() {
    // 重写获取配置信息
    this.getConfigList('consumer_redpacket_withdraw');
  },
};
